import React from 'react';
import { useInView } from 'react-intersection-observer';

import PageSection from '../PageSections/PageSection';
import ContentfulImage from './ContentfulImage';
import { ArrowLink } from './Links';
import RichTextConverter from './RichText/RichTextConverter';
import * as styles from './TwoColumnImageWithCards.module.scss';

export default function TwoColumnImageWithCards({ section }) {
  const { ref, inView } = useInView({
    threshold: 0.25,
    triggerOnce: true,
  });

  return (
    <PageSection
      slim
      wide
      className={[styles.section, styles[section.backgroundColor.toLowerCase()]].join(' ')}
      data-analytics-section={'two-column-image-with-cards'}
    >
      <h2>{section.heading}</h2>
      <div className={styles.columns} ref={ref}>
        <ContentfulImage
          imageFragment={section.mainImage}
          className={styles.image}
          lazy={true}
          data-analytics-component={'image'}
        />
        <div className={styles.divider} />
        <div className={styles.cards}>
          {section.content.map((card, i) => (
            <div
              key={i}
              data-analytics-component={'card'}
              data-analytics-id={card.linkLabel}
              className={[styles.card, styles[card.accentColor.toLowerCase()], inView ? styles.visible : ''].join(' ')}
            >
              <RichTextConverter copy={card.body} />
              <ArrowLink url={card.linkUrl} label={card.linkLabel} hoverAnimation />
            </div>
          ))}
        </div>
      </div>
    </PageSection>
  );
}
